import { request } from 'sonata-react-components';

export async function getNotificationsSettingsByUser(
  user: Record<string, any>,
  token: Record<string, any>
): Promise<any> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}userNotification/${user.id}`,
    {
      method: 'GET'
    },
    token
  );
}

export async function setNotificationsSettingsByUser(
  notificationsSettings: Record<string, any>,
  user: Record<string, any>,
  token: Record<string, any>
): Promise<any> {
  const id = notificationsSettings._id ? `/${notificationsSettings._id}` : '';
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}userNotification/${user.id}${id}`,
    {
      data: notificationsSettings,
      method: notificationsSettings._id ? 'PUT' : 'POST'
    },
    token
  );
}
